import { List, styled } from '@mui/material';

export const MenuList = styled(List, {
  shouldForwardProp: (prop) => prop !== 'component',
})<{ component?: React.ElementType }>(({ theme }) => ({
  background: 'none',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  '& .MuiListItemButton-root': {
    width: theme.spacing(5),
    height: theme.spacing(5),
    padding: theme.spacing(1),
    borderRadius: theme.spacing(2),
    marginBottom: theme.spacing(1),
    justifyContent: 'center',
    '& .MuiListItemIcon-root': {
      minWidth: 'unset',
    },
    '&.mui-menu-item-active, &:hover': {
      backgroundColor: theme.palette.primary.main,
    },
    '&.mui-menu-item-active .MuiListItemIcon-root, &.mui-menu-item-active .MuiListItemText-root, &:hover .MuiListItemIcon-root, &:hover .MuiListItemText-root':
      {
        color: '#FFFFFF',
      },
  },
}));
